import { MonitorTaskStatusEnum } from "../price-monitoring-task/enums/MonitorTaskStatusEnum"

export class AvailableActions {
  actions: Action[]
  messages: { message: string , image:string}[]
}

export class Action {
  currentStatus: string
  nextStatus: MonitorTaskStatusEnum
  class: any
  title: string
  actionId: number
  apiName: string
}
